import { SERVICE_URL } from "@app/config/getServiceUrl";
import { CLIENT_EVENT, EventLogger } from "@app/config/loggers/eventLogger";
import { markLoginAttempt, takeLoginAttempt } from "@base/lib/loginAttempt";
import { Image } from "@base/ui/Image";
import { useSafeAreaInset } from "@base/ui/SafeArea/useSafeAreaInset";
import { Button } from "@buildblockinc/buildblock-design-system";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

const LOGIN_CTA_BOTTOM_OFFSET_PX = 24;

function LoginPage() {
  const { bottom } = useSafeAreaInset();

  useEffect(function trackLoginView() {
    // 시도 표시가 남아 있다 = 구글에서 인증을 마치지 못하고 이 화면으로 되돌아왔다.
    // 지금까지 로그인 화면에는 계측이 없어 이 이탈이 데이터에 전혀 나타나지 않았다.
    const attempt = takeLoginAttempt();

    // TTL 을 넘긴 표시(durationMs === null)는 며칠 전 포기한 흔적일 수 있다.
    // 지금 막 돌아온 이탈과 섞으면 소요 시간 분포가 망가지므로 조용히 버린다.
    const isInFlightAttempt = attempt?.durationMs != null;

    if (isInFlightAttempt) {
      EventLogger.track(CLIENT_EVENT.LOGIN_ABANDON, { provider: "google", duration_ms: attempt.durationMs });
    }

    EventLogger.view(CLIENT_EVENT.LOGIN_VIEW, { is_retry: isInFlightAttempt });
  }, []);

  const handleGoogleLogin = () => {
    EventLogger.click(CLIENT_EVENT.LOGIN_CLICK, { provider: "google" });
    markLoginAttempt();
    window.location.href = `${SERVICE_URL}/ko/accounts/google/login?next=${SERVICE_URL}`;
  };

  const googleButton = (
    <Button
      variant="outline"
      color="secondary"
      className="justify-center w-full bg-white"
      prefixIcon={<img src="/assets/images/icons/google.svg" alt="" className="w-9 h-9 shrink-0" />}
      onClick={handleGoogleLogin}
      size="large"
    >
      <span className="text-black text-label2">Sign in with Google</span>
    </Button>
  );

  return (
    <div className="flex overflow-hidden justify-center items-center h-dvh bg-gray-10">
      <div className="flex w-full max-w-[400px] flex-col items-center px-4 gap-y-4 md:py-12 md:px-10 md:bg-white md:rounded-16 md:border md:border-gray-200">
        <Image
          src="/assets/images/app/bricks_logo.png"
          alt=""
          className="w-[79px]"
          sources={[{ srcSet: "/assets/images/app/bricks_logo.webp", type: "image/webp" }]}
        />
        <h1 className="text-blue-500 text-[40px] font-semibold leading-[100%] tracking-[-0.8px]">Bricks</h1>

        {/* 버튼은 하나만 둔다. 모바일은 safe area 위 하단 고정, PC는 카드 안에 배치한다 */}
        <div
          className="fixed right-0 bottom-0 left-0 p-4 bg-gray-10 pb-[var(--login-cta-bottom)] md:static md:p-0 md:mt-6 md:w-full md:bg-transparent"
          style={{ "--login-cta-bottom": `calc(${bottom}px + ${LOGIN_CTA_BOTTOM_OFFSET_PX}px)` } as React.CSSProperties}
        >
          {googleButton}
        </div>
      </div>
    </div>
  );
}
